// Local cache of the last successfully loaded transfer fares, so the pricing
// tables stay visible when the database is temporarily unavailable.
// The full Tarifs grid and the shorter homepage list are cached separately
// so one never overwrites the other.

const KEYS = {
  tarifs: "transfer_fares_cache_v1",
  home: "transfer_fares_home_cache_v1",
} as const;

export type FaresCacheScope = keyof typeof KEYS;

export interface CachedFares<T> {
  savedAt: string;
  fares: T[];
}

export function saveFaresCache<T>(fares: T[], scope: FaresCacheScope = "tarifs"): void {
  try {
    const payload: CachedFares<T> = { savedAt: new Date().toISOString(), fares };
    localStorage.setItem(KEYS[scope], JSON.stringify(payload));
  } catch {
    // storage full / unavailable — ignore
  }
}

export function loadFaresCache<T>(scope: FaresCacheScope = "tarifs"): CachedFares<T> | null {
  try {
    const raw = localStorage.getItem(KEYS[scope]);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CachedFares<T>;
    if (!parsed || !Array.isArray(parsed.fares)) return null;
    return parsed;
  } catch {
    return null;
  }
}
